import React from 'react';
import Button from '../Button'
import { Input } from 'reactstrap';
import './index.css';


class UtilityNav extends React.Component {

    state = {
        currentSelect: ''
    }

    componentDidMount() {
        if(this.props.columns){
            this.setState({
                currentSelect: this.props.columns[0].key
            })
        }
    }

    filterList = (evt) => {
        var searchTerm = evt.target.value;
        const filteredData = this.props.tableData.filter(
            (data) => {
                if (data[this.state.currentSelect] !== null) {
                    return (data[this.state.currentSelect].toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
                }
            }
        )
        this.props.FilterFunc(filteredData, searchTerm);
    }

    selectList = (evt) => {
        this.setState({
            currentSelect: evt.target.value
        })
    }
    render() {
        return (
            <div className="d-flex align-items-center header-container">
                <div className="d-flex align-items-center col-md-1 px-0">
                    <p className="action mb-0">Actions:</p>
                </div>
                {/* <div className="col-md-11">
                    <div className="row">
                    {
                        this.props.actionButtons.lenght == 0 && this.props.actionButtons == undefined ?
                        null :
                        this.props.actionButtons.map((val, key) => (
                            <div className="col-md-3 col-sm-4 col-xs-6">
                                <Button name={val.name} onClick={val.onClick} className="common-button" />
                            </div>
                        ))
                    }
                    </div>
                </div> */}
                <div className={this.props.searchBar ? "col-md-6 pl-0" : "col-md-10 pl-0"}>
                    {
                        this.props.actionButtons.lenght == 0 && this.props.actionButtons == undefined ?
                            null :
                            this.props.actionButtons.map((element, i) => (
                                <button title={element.title?element.title:''} disabled={element.disabled==='disabled'} key={i} onClick={() => { element.toggler(!element.togglerModal); this.props.modal(!this.props.showModal) }} style={element.disabled==='disabled'?{color:'grey'}:{color:'white'}} className="common-button">{element.name} {element.icon !== '' ? <i className={`${element.icon}` + " text-white"}></i> : ''}</button>
                            ))
                    }
                </div>
                {
                    this.props.searchBar ?
                        <div className="col-5">
                            {/* <div className="col-2 col-md-1 col-lg-1" style={{
                                width: 40,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <i className="fas fa-search text-white" />
                            </div> */}
                            <div className="row">
                                <div className="border-white px-1" style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}>
                                    <div className="d-flex flex-row justify-content-start" >
                                        <div className="input-group input-group-sm">
                                            <select className="form-control border-radius-zero" value={this.state.currentSelect} onChange={this.selectList}>
                                                {
                                                    this.props.columns.map((colData, pos) => {
                                                        if(pos === 0) {
                                                            return(
                                                                <option selected value={colData.key}>{colData.name}</option>
                                                            )
                                                        }else {
                                                            return(
                                                                <option value={colData.key}>{colData.name}</option>
                                                            )
                                                        }
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-white px-1" style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}>
                                    <div className="d-flex flex-row justify-content-start" >
                                        <div className="input-group input-group-sm">
                                            <input type="text" className="form-control border-radius-zero" aria-label="search" placeholder="Search..." aria-describedby="search" name="searchTerm"
                                                onChange={this.filterList}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    :
                        null
                }
            </div>
        )
    }
}

// const UtilityNav = (props) => {
    
//     return (
        
//     );
// }
export default UtilityNav;


// WEBPACK FOOTER //
// ./src/_components/common/UtilityNav/index.js